import { Record, List } from 'immutable';
import pick from 'lodash/pick';

import Organization from 'entities/organization/model';
import Campaign from 'entities/campaign/model';
import User from 'entities/user/model';
import Donation from 'entities/donation/model';

interface PaymentMethod {
  id: string;
  type: string;
}

interface ExecutionFailure {
  code: string;
  message: string;
  failedAt: string;
}

const properties = {
  id: '',
  frequency: '',
  startingAt: undefined,
  endingAt: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  amount: 0,
  status: '',
  currencyCode: '',
  description: '',
  designation: '',
  dedication: '',
  nonprofits: List(),
  privacy: '',
  provider: '',
  paymentMethod: undefined,
  user: undefined,
  executionFailure: List(),
  donations: List(),
  campaign: undefined,
};

export default class DonationSchedule
  extends Record(properties, 'DonationSchedule')
  implements DonationSchedule
{
  public readonly id!: string;

  public readonly frequency!: string;

  public readonly startingAt!: Date;

  public readonly endingAt!: Date;

  public readonly createdAt!: Date;

  public readonly amount!: number;

  public readonly currencyCode!: string;

  public readonly status!: string;

  public readonly nonprofits!: List<Organization>;

  public readonly campaign!: Campaign;

  public readonly privacy!: string;

  public readonly provider!: string;

  public readonly paymentMethod!: PaymentMethod;

  public readonly user!: User;

  public readonly executionFailure!: List<ExecutionFailure>;

  public readonly donations!: List<Donation>;

  public readonly description!: string;

  public readonly designation!: string;

  public readonly dedication!: string;

  constructor(values: any = {}) {
    const validValues = pick(values, Object.keys(properties));
    const user = values.user ?? values.User;
    const nonprofits = values.nonprofits ?? values.Nonprofits;
    const campaign = values.campaign ?? values.Campaign;
    const donations = values.donations ?? values.Donations;

    super({
      ...validValues,
      id: values._id || values.id,
      user: user && new User(user),
      nonprofits:
        nonprofits && List(nonprofits.map((nonprofit: any) => new Organization(nonprofit))),
      donations:
        donations &&
        List(
          donations.map(
            (donation: any) =>
              new Donation({
                ...donation,
                nonprofits: List(
                  (donation.Nonprofits || []).map((nonprofit: any) => new Organization(nonprofit))
                ),
              })
          )
        ),
      campaign: campaign && new Campaign(campaign),
      startingAt: values.startingAt ? new Date(values.startingAt) : undefined,
      endingAt: values.endingAt ? new Date(values.endingAt) : undefined,
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
    });
  }

  public isPayroll(): boolean {
    return this.paymentMethod?.type === 'Payroll';
  }
}
